import { useEffect, useRef, useState, useCallback } from 'react';

export function useParallax(speed: number = 0.12) {
  const ref = useRef<HTMLDivElement>(null);
  const [offset, setOffset] = useState(0);
  const rafId = useRef<number>(0);

  const update = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const elCenter = rect.top + rect.height / 2;
    const vpCenter = window.innerHeight / 2;
    setOffset((elCenter - vpCenter) * speed);
  }, [speed]);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const onScroll = () => {
      cancelAnimationFrame(rafId.current);
      rafId.current = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    update();

    return () => {
      window.removeEventListener('scroll', onScroll);
      cancelAnimationFrame(rafId.current);
    };
  }, [update]);

  return { ref, offset };
}